import { render, staticRenderFns } from "./Table-comp.vue?vue&type=template&id=48e783cd&scoped=true&"
import script from "./Table-comp.vue?vue&type=script&lang=js&"
export * from "./Table-comp.vue?vue&type=script&lang=js&"
import style0 from "./Table-comp.vue?vue&type=style&index=0&id=48e783cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e783cd",
  null
  
)

export default component.exports